"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _default = {
  none: "none",
  networkError: "networkError",
  noData: "noData",
  unknown: "unknown",
  sagaError: "sagaError",
  warning: "warning"
};
exports["default"] = _default;